import { render, staticRenderFns } from "./modalUpdatePinFeed.vue?vue&type=template&id=22475013&"
import script from "./modalUpdatePinFeed.vue?vue&type=script&lang=js&"
export * from "./modalUpdatePinFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports